import type { WalletRecipientView } from '@/api/address-book-bff/types';
import { theme, Typography } from '@/design-system';
import { truncateAddress } from '@/shared/modules/wallet/send/recipient';

import { getRecipientLabel } from './recipient-name';
import { SendRecipientAvatar } from './send-recipient-avatar';
import {
  ItemContent,
  ItemDetailRow,
  Option,
  TruncatedText,
} from './send-recipient-combobox.styled';

export const SendRecipientOption = ({ recipient }: { recipient: WalletRecipientView }) => (
  <Option value={recipient}>
    <SendRecipientAvatar recipient={recipient} />
    <ItemContent>
      <Typography
        as="span"
        variant="body3"
        fontWeight="medium"
        color={theme.colors.text.primary}
        noWrap
      >
        {getRecipientLabel(recipient)}
      </Typography>
      <ItemDetailRow>
        {recipient.email ? (
          <TruncatedText as="span" variant="body4" color={theme.colors.text.secondary}>
            {recipient.email}
          </TruncatedText>
        ) : null}
        <TruncatedText as="span" variant="body4" color={theme.colors.text.tertiary}>
          {truncateAddress(recipient.wallet.address)}
        </TruncatedText>
      </ItemDetailRow>
    </ItemContent>
  </Option>
);
